import { StyleSheet } from 'react-native'

const useStyles = (theme) => StyleSheet.create({
  container: {
    position: 'absolute',
    right: 0,
    top: 0,
    backgroundColor: theme.WHITE,
    zIndex: 1
  },
  header: {
    marginHorizontal: 20,
    marginTop: 10,
    alignItems: 'flex-end'
  }
})

export default useStyles
